/**
 * The day / week picker for the daily position views.
 *
 * Not PamGrid's built-in date select: that renders the value as the label, and a
 * week needs to read as 'Aug 10 – 14, 2026' rather than as the single date its
 * close happens to be. It also carries the restatement warning, which is a
 * property of the option rather than of the grid.
 */
import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

const PeriodSelect = ({ label, options, value, onChange, disabled }) => (
  <FormControl size="small" sx={{ minWidth: 240 }}>
    <InputLabel id="daily-period-label">{label}</InputLabel>
    <Select
      labelId="daily-period-label"
      label={label}
      value={value || ''}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
          {option.restated && (
            /* n_loads > 1: Clearwater sent this day more than once and a reload
               is a restatement, not a copy — a total that moved for that reason
               is not trading. */
            <Typography component="span" variant="caption" color="warning.main" sx={{ ml: 1 }}>
              (restated)
            </Typography>
          )}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default PeriodSelect;
